<template>
  <v-layout
    row
    justify-center
  >
    <v-dialog
      v-model="show"
      max-width="600"
      @input="v => v || closeDialog()"
    >
      <v-card>
        <v-card-title :class="colorTheme">
          <span class="headline white--text text-uppercase">Add Custom Field</span>
        </v-card-title>

        <v-card-text>
          <v-form
            ref="form"
            v-model="valid"
            lazy-validation
          >
            <v-container fluid>
              <v-layout
                row
                wrap
              >
                <v-flex
                  xs12
                  sm6
                >
                  <v-select
                    v-model="type"
                    :items="customFieldTypesArray"
                    item-text="name"
                    item-value="value"
                    label="Type"
                    :color="colorTheme"
                    @change="onTypeChange"
                  />
                </v-flex>
              </v-layout>
              <v-layout
                row
                wrap
              >
                <v-flex
                  xs12
                  sm6
                >
                  <v-text-field
                    v-model="name"
                    label="Name"
                    :color="colorTheme"
                  />
                </v-flex>
                <v-flex
                  xs12
                  sm6
                >
                  <custom-field
                    :type="type"
                    :color-theme="colorTheme"
                    label="Value"
                    :value="value"
                    :on-change="onChange"
                  />
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer />

          <v-btn
            :color="colorTheme"
            flat="flat"
            @click="closeDialog()"
          >
            cancel
          </v-btn>

          <v-btn
            :color="colorTheme"
            flat="flat"
            @click="submit()"
          >
            create
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import { customFieldTypesArray } from '@/enum/financialProducts/CustomFieldTypes';
import CustomField from './shared/CustomField';

export default {
  name: 'AddCustomField',
  components: { CustomField },
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    colorTheme: {
      type: String,
      default: 'blue',
    },
    submitAction: {
      type: Function,
      default: () => ({}),
    },
    cancelAction: {
      type: Function,
      default: () => ({}),
    },
  },
  data() {
    return {
      valid: true,
      show: this.dialog,
      datePicker: false,
      type: null,
      name: null,
      value: null,
      customFieldTypesArray,
      requiredRule: [
        v => !!v || 'field is required',
      ],
    };
  },
  watch: {
    dialog(val) {
      this.show = val;
    },
  },
  methods: {
    submit() {
      if (this.$refs.form.validate()) {
        this.submitAction({
          type: this.type,
          name: this.name,
          value: this.value,
        });
        this.setToDefault();
      }
    },
    closeDialog() {
      this.setToDefault();
      this.cancelAction();
    },
    onTypeChange() {
      this.value = null;
    },
    onChange(data) {
      this.value = data.value;
    },
    setToDefault() {
      this.type = null;
      this.name = null;
      this.value = null;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/financialProducts/AddCustomField.vue